import {
  ActuatorModalityType,
  ConfigurationType,
  Device,
  RoomObjectDTO,
  Slot,
  SlotStatus,
  ThermoActuatorType,
  RoomObjectType,
  ComponentType,
  DeviceDTO,
  LightType,
  FunctionType,
} from '@/../client-generator/generated-clients/plants';
import i18n from '../../translations/i18n';
import MxConstants from './mx-constants';
import ProtocolConstants from './protocol-constants';
import SlotsConfigService from './slots-assign-rules-config';
import {
  SlotRuleServiceType,
  WorkflowCallbackData,
  WorkflowCallbackFunction,
} from './slots-assign-rules-interfaces';
import BaseSlotRuleService from './slots-assign-rules-service';

export default class AssignCommandsAndGroupsSlotRuleService extends BaseSlotRuleService {
  _adjacentSlotVm: Slot | null = null;

  constructor(
    roomObject: RoomObjectDTO,
    workflowCallback: WorkflowCallbackFunction
  ) {
    super(
      roomObject,
      -1,
      ThermoActuatorType.None,
      ActuatorModalityType.None,
      workflowCallback
    );
    this.slotRuleServiceType = SlotRuleServiceType.COMMANDS_AND_GROUPS;

    this._noOfAdjacent = this.OneAdjacent;
  }
  isLinkedWithCurrentRoomObject(objectSlot: Slot) {
    return (
      objectSlot.linkedObjects?.some(
        (linkedRoomObject) => linkedRoomObject.id == objectSlot.id
      ) ?? false
    );
  }

  onSlotMessage(device: DeviceDTO, slot: Slot) {
    const is8BtnDeviceOrCrystalDeviceWithPairSelection = SlotsConfigService.is8BtnDeviceOrCrystalDeviceWithPairSelection(
      device
    );

    switch (slot.status) {
      case SlotStatus.Configured:
        {
          if (this.isLinkedWithCurrentRoomObject(slot)) {
            const data: WorkflowCallbackData = {
              warningTitle: `${i18n.global.t(
                'AppResource.UnlinkThe'
              )} ${i18n.global.t('AppResource.Module')}`,
              warningMessage: `${i18n.global.t(
                'AppResource.UnlinkMessage'
              )} ${i18n.global.t('AppResource.Module')} ${
                slot.index
              } ${i18n.global.t('AppResource.From')} ${this.roomObject.name}?`,
              _isUnlinkFlow: true,
              isWarningRequested: true,
            };
            this._workflowCallback(
              data,
              () => this.doYesCommand(data, device, slot),
              () => this.doNoCommand(data, device, slot),
              () => this.doAlertCommand(data, device, slot)
            );
            this._adjacentSlotVm =
              device.slots?.find(
                (sl) =>
                  sl != null &&
                  sl.configurationType != ConfigurationType.None &&
                  slot &&
                  slot.index &&
                  (sl.index == slot.index + 1 || sl.index == slot.index - 1) &&
                  (sl.status == SlotStatus.MarkedForLinking ||
                    (sl.status == SlotStatus.Configured &&
                      this.isLinkedWithCurrentRoomObject(sl))) &&
                  sl.assignedComponentType == ComponentType.Actuator
              ) || null;
          }
        }
        break;
      case SlotStatus.NotConfigured:
        {
          if (
            device.modelObject === ProtocolConstants.Device1_5_119 &&
            (this.roomObject.type == RoomObjectType.Shutter ||
              this.roomObject.type == RoomObjectType.Blind)
          ) {
            this._noOfAdjacent = this.ThreeAdjacent;
            this.markOrUnmarkSlot(
              this.roomObject,
              slot,
              device,
              SlotStatus.NotConfigured,
              SlotStatus.MarkedForLinking
            );
          } else if (
            (this.roomObject.type == RoomObjectType.Shutter &&
              is8BtnDeviceOrCrystalDeviceWithPairSelection) ||
            (this.roomObject.type == RoomObjectType.Blind &&
              is8BtnDeviceOrCrystalDeviceWithPairSelection)
          ) {
            this._noOfAdjacent = this.TwoAdjacent;
            this.markOrUnmarkSlot(
              this.roomObject,
              slot,
              device,
              SlotStatus.NotConfigured,
              SlotStatus.MarkedForLinking,
              false,
              true
            );
          } else {
            this._noOfAdjacent = this.OneAdjacent;

            const temSlots = device.slots?.filter(
              (sl) =>
                sl != null &&
                sl.configurationType == ConfigurationType.None &&
                slot &&
                slot.index &&
                (sl.index == slot.index + 1 || sl.index == slot.index - 1) &&
                (sl.status == SlotStatus.MarkedForLinking ||
                  (sl.status == SlotStatus.Configured &&
                    this.isLinkedWithCurrentRoomObject(sl))) &&
                sl.assignedComponentType == ComponentType.Command
            );
            this._adjacentSlotVm = temSlots
              ? temSlots[temSlots?.length - 1] || null
              : null;

            var isDevice15117orDevice15121orDevice15119 =
              device.modelObject &&
              (device.modelObject === ProtocolConstants.Device1_5_117 ||
                device.modelObject === ProtocolConstants.Device1_5_121 ||
                device.modelObject === ProtocolConstants.Device1_5_119 ||
                device.modelObject === ProtocolConstants.Device0_0_121);

            // MXSRV-1841
            var isDevice3477 =
              device.modelObject &&
              (device.modelObject === ProtocolConstants.Device1_0_152 ||
                device.modelObject === ProtocolConstants.Device2_2_152);

            // MXSRV-1875
            var isDeviceF428 =
              device.modelObject &&
              (device.modelObject === ProtocolConstants.Device1_0_149 ||
                device.modelObject === ProtocolConstants.Device2_0_149);

            //MXSRV-1876
            var isDeviceCrystal8Scene =
              device.modelObject &&
              (device.modelObject === ProtocolConstants.Device2_2_17 ||
                device.modelObject === ProtocolConstants.Device2_4_17 ||
                device.modelObject === ProtocolConstants.Device1_3_27 ||
                device.modelObject === ProtocolConstants.Device2_2_27 ||
                device.modelObject === ProtocolConstants.Device1_3_28 ||
                device.modelObject === ProtocolConstants.Device1_3_49 ||
                device.modelObject === ProtocolConstants.Device1_1_49 ||
                device.modelObject === ProtocolConstants.Device2_4_49);

            if (
              this._adjacentSlotVm &&
              !isDevice15117orDevice15121orDevice15119 &&
              !isDevice3477 &&
              !isDeviceF428 &&
              !isDeviceCrystal8Scene
            ) {
              const data: WorkflowCallbackData = {
                warningTitle: i18n.global.t(
                  'AppResource.MostrineQuestionTitle'
                ),
                warningMessage: i18n.global.t('AppResource.MostrineQuestion'),
                isConfirmation: true,
                isWarningRequested: true,
              };
              this._workflowCallback(
                data,
                () => this.doYesCommand(data, device, slot),
                () => this.doNoCommand(data, device, slot),
                () => this.doAlertCommand(data, device, slot)
              );
            } else {
              if (this.isSpecialDeviceF428(slot, device)) {
                //LR if true, there is only one slot left in device with model: F428
                var adjacentSlotVm = device.slots?.find(
                  (sl) =>
                    sl.status == SlotStatus.NotConfigured &&
                    slot &&
                    slot.index &&
                    (sl.index == slot.index + 1 || sl.index == slot.index - 1)
                );
                if (adjacentSlotVm != null) {
                  this.addOrUpdateSlot(slot);
                  this.addOrUpdateSlot(adjacentSlotVm);
                  this.updateConfigurationType(
                    slot,
                    adjacentSlotVm,
                    ConfigurationType.None
                  );
                } else {
                  const data: WorkflowCallbackData = {
                    warningTitle: i18n.global.t(
                      'AppResource.NotEnoughAdjacentChannelsTitle'
                    ),
                    warningMessage: i18n.global.t(
                      'AppResource.NotEnoughAdjacentChannelsMessage'
                    ),
                    isConfirmation: false,
                    isWarningRequested: true,
                  };
                  this._workflowCallback(
                    data,
                    () => this.doYesCommand(data, device, slot),
                    () => this.doNoCommand(data, device, slot),
                    () => this.doAlertCommand(data, device, slot)
                  );
                }
              } else {
                this.addOrUpdateSlot(slot);
              }
            }
          }
        }
        break;
      case SlotStatus.MarkedForLinking:
        {
          if (device.modelObject == ProtocolConstants.Device1_5_119 &&
            (this.roomObject.type == RoomObjectType.Shutter || this.roomObject.type == RoomObjectType.Blind ))
          {
            this._noOfAdjacent = this.ThreeAdjacent;
            this.markOrUnmarkSlot(this.roomObject, slot, device, SlotStatus.MarkedForLinking, SlotStatus.NotConfigured);
          }
          else if ((this.roomObject.type == RoomObjectType.Shutter &&
                is8BtnDeviceOrCrystalDeviceWithPairSelection) || (this.roomObject.type == RoomObjectType.Blind &&
                is8BtnDeviceOrCrystalDeviceWithPairSelection))
          {
            this._noOfAdjacent = this.TwoAdjacent;
            this.markOrUnmarkSlot(this.roomObject, slot, device, SlotStatus.MarkedForLinking, SlotStatus.NotConfigured);
          }
          else
          {
            this._noOfAdjacent = this.OneAdjacent;
            slot.status = SlotStatus.NotConfigured;
              this._adjacentSlotVm = device.slots?.find(sl => sl != null && sl.configurationType != ConfigurationType.None && (slot && slot.index && (sl.index == slot.index + 1 || sl.index == slot.index - 1)) && (sl.status == SlotStatus.MarkedForLinking || (sl.status == SlotStatus.Configured && this.isLinkedWithCurrentRoomObject(sl)))) || null;
            if (slot.configurationType != ConfigurationType.None)
            {
              this.updateConfigurationType(slot, this._adjacentSlotVm, ConfigurationType.None);
            }
            this.removeOrUpdateSlot(slot);
            if (this._adjacentSlotVm && this.isSpecialDeviceF428(slot, device))
            {
              this.removeOrUpdateSlot(this._adjacentSlotVm);
            }
          }
        }
        break;
      case SlotStatus.NotUsed:
      default:
        break;
    }
  }

  isSlotCompatibleForMarking(slot: Slot) {
    return (
      this.isSlotRoomObjectTypeMatchingAndNotLinked(slot) &&
      slot.status != SlotStatus.MarkedForLinking
    );
  }

  isSpecialDeviceF428(slot: Slot, device: Device) {
    if (slot != null && this.roomObject?.type == RoomObjectType.Shutter) {
      if (device != null && device.model == MxConstants.F428) {
        return true;
      }
    }

    return false;
  }

  updateConfigurationType(
    selectedSlotViewModel: Slot | null,
    adjacentSlotViewModel: Slot | null,
    configurationType: ConfigurationType
  ) {
    if (selectedSlotViewModel != null) {
      selectedSlotViewModel.configurationType = configurationType;
    }
    if (adjacentSlotViewModel != null) {
      adjacentSlotViewModel.configurationType = configurationType;
    }
  }

  areSlotsCompatibleForPresetManagement(device: DeviceDTO) {
    if (this.roomObject?.devices != null && device != null) {
      const isShutterRoomObject =
        this.roomObject.type == RoomObjectType.Shutter;
      const isActuatorModelCorrect = this.roomObject.devices.some((d) =>
        this.isActuatorModelCorrect(d)
      );
      const isLastComponentCollapsed = !!device.model;
      const commandCanHandlePreset = this.hasCommandThatCanHandlePreset(device);

      return (
        isShutterRoomObject &&
        isActuatorModelCorrect &&
        isLastComponentCollapsed &&
        commandCanHandlePreset
      );
    }
    return false;
  }

  isActuatorModelCorrect(d: DeviceDTO) {
    const deviceHasCorrectFunctionType =
      d.functionType == FunctionType.All ||
      d.functionType == FunctionType.Automation;
    const devicheHasModel = !!d.model;
    const deviceIsActuatorWithAbailableSlots =
      d.slots != null &&
      d.slots.some(
        (s) =>
          (s.status == SlotStatus.MarkedForLinking ||
            s.status == SlotStatus.Configured) &&
          (s.assignedComponentType == ComponentType.Actuator ||
            s.assignedComponentType == ComponentType.None)
      );

    return (
      deviceHasCorrectFunctionType &&
      devicheHasModel &&
      d.isShutterWithPosition &&
      deviceIsActuatorWithAbailableSlots
    );
  }

  hasCommandThatCanHandlePreset(device: DeviceDTO) {
    return device?.canHandlePreset ?? false;
  }

  doNoCommand(data: WorkflowCallbackData, device: DeviceDTO, slot: Slot) {
    super.doNoCommand(data, device, slot);
    if (data._isMostrineFlow)
    {
      this.addOrUpdateSlot(slot);
      data._isMostrineFlow = false;
    }
    data._isUnlinkFlow = false;
  }

  doYesCommand(data: WorkflowCallbackData, device: DeviceDTO, slot: Slot) {    
    if (slot != null)
    {
      if (data._isUnlinkFlow)
      {
        if (slot.configurationType == ConfigurationType.Mostrine && this._adjacentSlotVm != null)
        {
          this.updateMostrineStatus(slot, this._adjacentSlotVm, ConfigurationType.None);
        }
        this.removeOrUpdateSlot(slot);
        data._isUnlinkFlow = false;
      }
      else if (this._adjacentSlotVm && data._isMostrineFlow)
      {
        this.addOrUpdateSlot(slot);
        this.updateMostrineStatus(slot, this._adjacentSlotVm, ConfigurationType.Mostrine);
        data._isMostrineFlow = false;
      }
    }
  }

  doPresetNoCommand(data: WorkflowCallbackData, device: DeviceDTO, slot: Slot) {
    this.addOrUpdateSlot(slot);
  }

  doPresetYesCommand(
    data: WorkflowCallbackData,
    device: DeviceDTO,
    slot: Slot
  ) {
    this.addOrUpdateSlot(slot);
    this.updateConfigurationType(
      slot,
      this._adjacentSlotVm,
      ConfigurationType.Preset
    );
  }
}
